import { faUserCircle } from "@fortawesome/pro-regular-svg-icons";
import { faStar } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { get_cdn_url, use_store } from "../store";

export const ReviewSection = () => {
  const { t } = use_store();
  return (
    <div className="flex flex-col gap-[24px] w-full flex-col items-start">
      <p className="stitle w-full">{t("What People Are Saying")}</p>
      <div className="flex flex-col gap-[12px] justify-center items-center">
        <div className="py-[20px] px-[16px] bg-surface border-lines border-[1px] rounded-[4px] w-full">
          <div className="flex flex-row gap-[4px] mb-[12px]">
            {[1, 2, 3, 4, 5].map((i) => {
              return (
                <FontAwesomeIcon
                  key={`icon-${i}`}
                  icon={faStar}
                  className="text-brand-2 vsmallt"
                ></FontAwesomeIcon>
              );
            })}
          </div>
          <p className="vsmallt mb-[8px]">
            {t(
              "I was exhausted from a relationship full of lies, so I just checked his follows, then I left.",
            )}
          </p>
          <div className="flex flex-row gap-[8px] items-center">
            <img
              className="w-[16px] h-[16px] rounded-full"
              src={get_cdn_url("/faces/face1.webp")}
            ></img>
            <p className="vsmallt_med">{t("Annie M.")}</p>
          </div>
        </div>

        <div className="py-[20px] px-[16px] bg-surface border-lines border-[1px] rounded-[4px] w-full">
          <div className="flex flex-row gap-[4px] mb-[12px]">
            {[1, 2, 3, 4, 5].map((i) => {
              return (
                <FontAwesomeIcon
                  key={`icon-${i}`}
                  icon={faStar}
                  className="text-brand-2 vsmallt"
                ></FontAwesomeIcon>
              );
            })}
          </div>
          <p className="vsmallt mb-[8px]">
            {t(
              "“Noticed my hubby followed 5 new accounts, and it made me feel anxious. Thanks to this, I saw it was nothing to worry about.”",
            )}
          </p>
          <div className="flex flex-row gap-[8px] items-center">
            <FontAwesomeIcon
              className="text-[16px] text-primary"
              icon={faUserCircle}
            ></FontAwesomeIcon>
            <p className="vsmallt_med">{t("Anonymous User")}</p>
          </div>
        </div>

        <div className="py-[20px] px-[16px] bg-surface border-lines border-[1px] rounded-[4px] w-full">
          <div className="flex flex-row gap-[4px] mb-[12px]">
            {[1, 2, 3, 4, 5].map((i) => {
              return (
                <FontAwesomeIcon
                  key={`icon-${i}`}
                  icon={faStar}
                  className="text-brand-2 vsmallt"
                ></FontAwesomeIcon>
              );
            })}
          </div>
          <p className="vsmallt mb-[8px]">
            {t(
              "“Caught him following OnlyFans models and porn people, thank god I left.“",
            )}
          </p>
          <div className="flex flex-row gap-[8px] items-center">
            <img
              className="w-[16px] h-[16px] rounded-full"
              src={get_cdn_url("/faces/face3.webp")}
            ></img>
            <p className="vsmallt_med">{t("Jenny L.")}</p>
          </div>
        </div>

        <div className="py-[20px] px-[16px] bg-surface border-lines border-[1px] rounded-[4px] w-full">
          <div className="flex flex-row gap-[4px] mb-[12px]">
            {[1, 2, 3, 4, 5].map((i) => {
              return (
                <FontAwesomeIcon
                  key={`icon-${i}`}
                  icon={faStar}
                  className="text-brand-2 vsmallt"
                ></FontAwesomeIcon>
              );
            })}
          </div>
          <p className="vsmallt mb-[8px]">
            {t(
              "“I feel relaxed knowing that everything is cool with my girl. Makes a difference for sure.“",
            )}
          </p>
          <div className="flex flex-row gap-[8px] items-center">
            <img
              className="w-[16px] h-[16px] rounded-full"
              src={get_cdn_url("/faces/face6.webp")}
            ></img>
            <p className="vsmallt_med">{t("Connor S.")}</p>
          </div>
        </div>

        <div className="py-[20px] px-[16px] bg-surface border-lines border-[1px] rounded-[4px] w-full">
          <div className="flex flex-row gap-[4px] mb-[12px]">
            {[1, 2, 3, 4, 5].map((i) => {
              return (
                <FontAwesomeIcon
                  key={`icon-${i}`}
                  icon={faStar}
                  className="text-brand-2 vsmallt"
                ></FontAwesomeIcon>
              );
            })}
          </div>
          <p className="vsmallt mb-[8px]">
            {t(
              "“Could instantly see what was happening and could decide what to do from there.“",
            )}
          </p>
          <div className="flex flex-row gap-[8px] items-center">
            <FontAwesomeIcon
              className="text-[16px] text-primary"
              icon={faUserCircle}
            ></FontAwesomeIcon>
            <p className="vsmallt_med">{t("Anonymous User")}</p>
          </div>
        </div>
      </div>
    </div>
  );
};
